import React from 'react'
export const ClickMenuContext = React.createContext({
    currentPage: 0,
    handleClickMenu: () => {

   }
});